export default __webpack_public_path__ + "static/feigningSick-7a16f295329b6b3d5ce6cf5c7a8b05b0.svg";